(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3395],{

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StarsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/stars/stars-component.scss.js

var StyledStarsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ek31l9l0"
})("display:flex;justify-content:center;.star-icon-wrapper{&:not(:last-child){margin-right:8px;}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/core/stars/stars-component.js










var StarsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(StarsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(StarsComponent);
    function StarsComponent() {
        (0,_class_call_check/* default */.Z)(this, StarsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(StarsComponent, [
        {
            key: "renderStars",
            value: function renderStars() {
                var _props = this.props, numberOfSelectedStars = _props.numberOfSelectedStars, starsCount = _props.starsCount;
                var numberOfSelectedStarsAsInt = parseInt(numberOfSelectedStars);
                var starsCountAsInt = parseInt(starsCount);
                return times_default()(starsCountAsInt, function(index) {
                    var isSelected = numberOfSelectedStarsAsInt > index;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("star-icon-wrapper", {
                            selected: isSelected
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: "/static/img/star.png"
                        })
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var paddingTop = this.props.paddingTop;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStarsComponent, {
                    className: "stars-component",
                    style: {
                        paddingTop: paddingTop
                    },
                    children: this.renderStars()
                });
            }
        }
    ]);
    return StarsComponent;
}(react.PureComponent);

StarsComponent.defaultProps = {
    paddingTop: 0,
    numberOfSelectedStars: "5",
    starsCount: "5"
};


/***/ }),

/***/ 46998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);

/* harmony default export */ __webpack_exports__["Z"] = ({
    name: "Jeff E.",
    jobDescription: "Software Application Specialist Mechanical or Industrial Engineering",
    color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
});


/***/ }),

/***/ 16438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PersonTextualInfo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/person-textual-info/person-textual-info.scss.js

var StyledPersonTextualInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1w2qszs0"
})("font-size:1.125rem;line-height:30px;.person-name{font-weight:700;}@media (max-width:720px){font-size:1rem;line-height:30px;}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/default-props.js
var default_props = __webpack_require__(46998);
;// CONCATENATED MODULE: ./segments/desktop/core-components/person-textual-info/person-textual-info.js









var PersonTextualInfo = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PersonTextualInfo, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PersonTextualInfo);
    function PersonTextualInfo() {
        (0,_class_call_check/* default */.Z)(this, PersonTextualInfo);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PersonTextualInfo, [
        {
            key: "getTextualInfoStyle",
            value: function getTextualInfoStyle() {
                var color = this.props.color;
                return {
                    color: color
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, name = _props.name, jobDescription = _props.jobDescription, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPersonTextualInfo, {
                    className: classnames_default()("person-textual-info", className),
                    style: this.getTextualInfoStyle(),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "person-name",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "seperator",
                            children: " | "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "person-job-description",
                            children: jobDescription
                        })
                    ]
                });
            }
        }
    ]);
    return PersonTextualInfo;
}(react.PureComponent);

PersonTextualInfo.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 71511:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    REVIEW_CARD_HEIGHT: 472,
    REVIEW_CARD_WIDTH: 410,
    MOBILE_REVIEW_CARD_WIDTH: 300
});


/***/ }),

/***/ 6652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);
/* harmony import */ var segments_desktop_core_components_person_textual_info_default_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46998);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ __webpack_exports__["Z"] = (_object_spread({
    title: "“The virtual manager that all work needs“",
    fontSize: "24px",
    showStars: true,
    starsCount: 5,
    decorationColor: "iris",
    reviewCardOverrideHeight: null
}, segments_desktop_core_components_person_textual_info_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 13716:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    REVIEW_CARD_MARGIN: 56
});


/***/ }),

/***/ 63395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Reviews; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/stars/stars-component.js + 1 modules
var stars_component = __webpack_require__(763);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/person-textual-info.js + 1 modules
var person_textual_info = __webpack_require__(16438);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./segments/desktop/core-components/review-card/constants.js
var review_card_constants = __webpack_require__(71511);
;// CONCATENATED MODULE: ./segments/desktop/core-components/review-card/review-card.scss.js





var REVIEW_CARD_HEIGHT = "".concat(review_card_constants/* default.REVIEW_CARD_HEIGHT */.Z.REVIEW_CARD_HEIGHT, "px");
var REVIEW_CARD_WIDTH = "".concat(review_card_constants/* default.REVIEW_CARD_WIDTH */.Z.REVIEW_CARD_WIDTH, "px");
var MOBILE_REVIEW_CARD_WIDTH = "".concat(review_card_constants/* default.MOBILE_REVIEW_CARD_WIDTH */.Z.MOBILE_REVIEW_CARD_WIDTH, "px");
var StyledReviewCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4iyx9m0"
})("height:", REVIEW_CARD_HEIGHT, ";width:", REVIEW_CARD_WIDTH, ";background:", colors/* default.white */.Z.white, ";", (0,constants.getComponentShadow)(), "  display:flex;flex-direction:column;align-items:center;.review-card-color-decoration{height:10px;width:100%;}.review-card-quote-title{width:100%;flex-grow:1;padding:32px;text-align:center;overflow:hidden;line-height:36px;}.review-card-stars{margin-bottom:16px;}.review-card-quote-name{text-align:center;margin-bottom:24px;padding:0 16px;.review-card-person-info{font-size:1rem;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){width:", MOBILE_REVIEW_CARD_WIDTH, ";.review-card-quote-title{font-size:1rem !important;// overide inline style\n      line-height:30px !important;}.review-card-quote-name{.review-card-person-info{font-size:0.844rem;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/review-card/default-props.js
var default_props = __webpack_require__(6652);
;// CONCATENATED MODULE: ./segments/desktop/core-components/review-card/review-card.js











var ReviewCard = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ReviewCard, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ReviewCard);
    function ReviewCard() {
        (0,_class_call_check/* default */.Z)(this, ReviewCard);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ReviewCard, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, decorationColor = _props.decorationColor, starsCount = _props.starsCount, name = _props.name, jobDescription = _props.jobDescription, title = _props.title, showStars = _props.showStars, fontSize = _props.fontSize, reviewCardOverrideHeight = _props.reviewCardOverrideHeight;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReviewCard, {
                    className: "review-card",
                    style: {
                        height: reviewCardOverrideHeight
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "review-card-color-decoration",
                            style: {
                                backgroundColor: colors/* default */.Z[decorationColor]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "review-card-quote-title",
                            style: {
                                fontSize: fontSize
                            },
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        showStars && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "review-card-stars",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_component/* default */.Z, {
                                starsCount: starsCount
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "review-card-quote-name",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(person_textual_info/* default */.Z, {
                                name: name,
                                jobDescription: jobDescription,
                                color: colors/* default.mud */.Z.mud,
                                className: "review-card-person-info"
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ReviewCard;
}(react.PureComponent);

ReviewCard.defaultProps = default_props/* default */.Z;

// EXTERNAL MODULE: ./segments/desktop/core-components/reviews/constants.js
var reviews_constants = __webpack_require__(13716);
;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews/reviews.scss.js



var StyledReviews = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e5k36ai0"
})("display:flex;.review-card-component-wrapper{flex-shrink:0;&:not(:last-child){margin-right:", reviews_constants/* default.REVIEW_CARD_MARGIN */.Z.REVIEW_CARD_MARGIN, "px;}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){flex-direction:column;.review-card-component-wrapper{&:not(:last-child){margin-right:0;margin-bottom:", reviews_constants/* default.REVIEW_CARD_MARGIN */.Z.REVIEW_CARD_MARGIN, "px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ var reviews_default_props = ({
    reviews: [
        _object_spread_props(_object_spread({}, default_props/* default */.Z), {
            decorationColor: "green",
            title: '"I used monday.com to manage a marketing campaign and had all the stake holders on it, from client to designer, everyone was on the platform. "'
        }),
        _object_spread_props(_object_spread({}, default_props/* default */.Z), {
            decorationColor: "iris",
            title: '"monday.com is excellent. I keep track of everything with it: client projects, marketing calendar, employee time off, expenses, payments & invoicing, company revenue"'
        })
    ],
    reviewCardOverrideHeight: null
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews/reviews.js




function reviews_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reviews_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reviews_define_property(target, key, source[key]);
        });
    }
    return target;
}
function reviews_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reviews_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reviews_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var Reviews = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Reviews, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Reviews);
    function Reviews(props) {
        (0,_class_call_check/* default */.Z)(this, Reviews);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(Reviews, [
        {
            key: "renderReviews",
            value: function renderReviews() {
                var _props = this.props, cardFontSize = _props.cardFontSize, reviews = _props.reviews, reviewCardOverrideHeight = _props.reviewCardOverrideHeight;
                return reviews.map(function(review, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "review-card-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCard, reviews_object_spread_props(reviews_object_spread({}, review), {
                            fontSize: cardFontSize,
                            reviewCardOverrideHeight: reviewCardOverrideHeight
                        }))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReviews, {
                    className: "reviews",
                    children: this.renderReviews()
                });
            }
        }
    ]);
    return Reviews;
}(react.PureComponent);

Reviews.defaultProps = reviews_default_props;


/***/ })

}]);